var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1291",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1291)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -8,
    width: 65,
    height: 79,
    fill: "#029491"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_1291",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_1291",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAABmJLR0QA/wD/AP+gvaeTAAAEw0lEQVR4nO2b3YuUVRzHP9u4K7r2MrujkNnu0kWm67ZhXkQIlRBSFBgsSBZeZd2I0V1p9TcoCmFEYFCKNxKJSYHetBU49qKx7RquFyJI7RahOVu5s178npHn+T1vM+ec56zifOCBPfM88/19z9lzznPeBtq0adPGDwPAXJPXgC9Td/kKBDxd0LNW+CyApwp69rbhAs03gQvz5LHNHUeHpzh9wAZgHbAS6eV7gSXB/avANFL1zwGngBPARU/+CqEfeBf4lebbvr7GgF2B1m3DEPAJcB3zjOtrFvgCqUG3LD3AfqCOu4zrq44U7jJPeWqazcCfpBuvIW36PWATsAooA53BVQ4+2wS8Hzw7k6E3DYx4yVkOXcAHpBs9BbwG3GugfR+wDahm6O9DCnBe6AaOpxirAs86jLUR+CEl1rHAi1e6gW8TzPwDbAdKBcQsATuAawlxR/FYCF0k/+fHgEEP8YeA8YT4x/DUHJLa/CjSkbVKLbhapYfkGrjXQKslNicEHQUWG2gtCmksMvh+WjMs7O2wjPirbgyz/zzA8pDOckONXuLNYRqoGOplckAFqgHDFnqDIa3VFjprkM437O0jC71EHiM+wttuqbk+pLXeUutNot7qSGfpjMMqQBX7V92LIb0XLLVKxMcJn1lq3mQAmYyExV0McraG9LY60HuOqMfryDQ8k2bWBF9Vz1WBrw0Masopf5vyJVILGpQQ75k0UwCvqPT+Fkxl4boAIO5ti61gH/Ge32Rik8SekO4eR5pl4F+inldkfSGvBmxQ6e+Av03dKYqoAX8hHsPoPETIK4DHVfpkq44yKKIAIO5R5yFCXgGsVOkzLdtJpg8ZwDRYg7t1P+1R56ElzhNtT4/YiAX0I8NVPYafwk0hrFa6v9mITSmxXlt3wEHimXc5eKkozT9sxHSP2mXrLjCUVgBWZgMWKs2ZrId9bo42mM24V/fmIiCvAK6q9JLEp1rjq4x7xx3o36PSV2zEdCe4ykYs4CHgMvHqfzm4Z0t4mp3bCebVgPMq/bC5r5tMAk8Ch4Dfg+tg8NmkA33tUechwoIcsQmiM79h4HMDU5pJ4GUHOknoRZqJrIfzasBplfZ2dMWCZ1S6aiOmJ0MzyI7NrUrSZOgBW9ExJbjNVrBA3iDq9awL0V1K1KpKFUgH8WWxt10I9xPf69/oQtgxzxNfEnvQlfghJX6G/DeIT0rAT0Q9fuoywKPEl8V3uAxgyVtEvc1SwD7lxypIDdkvmG+GiO8Yf1hEoKXE5/HjuJkim1JBTpXpGWVhnkZUsDlkg9L7AYUg5vfKSx14qejA+0guBJ81oYIsfmofu30E70QOI+jg4zjej0thmHi1nwOO4vHN1I2cC9AmriEblUUckVmA9Pa1hLjfYHZGwYpukmvCHPAjslfngg5kkPNzSqyjzEPmG3Qix1LS1vhOI+Nzk3X/cvDdtNNhdaTNW1V7V4elR5B9uZ6U+/8hndZJZBR5DlkBaixX3Q3cjyxmDCG7OU+Qvgg7BbwOHHHg3Rk9yB6f3kp3eTWOyi71lCcjBhGT/+Mu443D0ms95sOaPmAn8AvmGT8LvIPDWZ3G1w8mVhD/wUSF6A8mppAfTEwgaw4ngEue/LVp0+YO5QbkJEUZhK6kegAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.1fac99ab9c899850347b676d26527f23.svg";
export { ForwardRef as ReactComponent };